import { render, staticRenderFns } from "./PackageMemberDialog.vue?vue&type=template&id=24a419ae&scoped=true"
import script from "./PackageMemberDialog.vue?vue&type=script&lang=js"
export * from "./PackageMemberDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageMemberDialog.vue?vue&type=style&index=0&id=24a419ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a419ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a419ae')) {
      api.createRecord('24a419ae', component.options)
    } else {
      api.reload('24a419ae', component.options)
    }
    module.hot.accept("./PackageMemberDialog.vue?vue&type=template&id=24a419ae&scoped=true", function () {
      api.rerender('24a419ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/PackageMemberDialog.vue"
export default component.exports